/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2020 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { antenatalattendancestat } from './antenatalattendancestat';
import { labordeliverystat } from './labordeliverystat';
import { patientindex } from '../domain/patientindex';
import { viralstat } from './viralstat';
import { accountingsummary } from './accountingsummary';
import { coderesult, guidelinesummary, limitandsurveyresult, resultinformation, resultsummary } from '../../services/cds/guidelinesummary';
import { alert } from '../system/alert';

export class patientstat extends patientindex {
  age: number = 0.0;
  weeks: number = 0.0;
  ANTENATAL_ATTENDANCE_STAT: antenatalattendancestat[] = [];
  LABOR_DELIVERY_STAT: labordeliverystat[] = [];
  VIRAL_STAT: viralstat[] = [];
  ACCOUNTING_SUMMARY: accountingsummary[] = [];
  CDSGLDATA: guidelinesummary[] = [];
  CDSALERTSBYGL: alert[] = [];
  CDSRESULTSBYKEY: resultinformation[] = [];
  CDSRESULTS: resultsummary[] = []

  public gettablename(): string {
    return "PATIENT_STAT";
  }

  public hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "ANTENATAL_ATTENDANCE_STAT") return true;
    else if (ColumnName == "LABOR_DELIVERY_STAT") return true;
    else if (ColumnName == "VIRAL_STAT") return true;
    else if (ColumnName == "ACCOUNTING_SUMMARY") return true;
    else if (ColumnName == "CDSGLDATA") return true;
    else if (ColumnName == "CDSALERTSBYGL") return true;
    else if (ColumnName == "CDSRESULTSBYKEY") return true;
    else if (ColumnName == "CDSRESULTS") return true;

    return false;
  }

  public getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "ANTENATAL_ATTENDANCE_STAT") return "ANTENATAL_ATTENDANCE_STAT";
    else if (ColumnName == "LABOR_DELIVERY_STAT") return "LABOR_DELIVERY_STAT";
    else if (ColumnName == "VIRAL_STAT") return "VIRAL_STAT";
    else if (ColumnName == "ACCOUNTING_SUMMARY") return "ACCOUNTING_SUMMARY";
    else if (ColumnName == "CDSGLDATA") return "GUIDELINE_SUMMARY";
    else if (ColumnName == "CDSALERTSBYGL") return "ALERT";
    else if (ColumnName == "CDSRESULTSBYKEY") return "RESULT_INFORMATION,CodeResult,LimitAndSurveyResult";
    else if (ColumnName == "CDSRESULTS") return "Result";

    return null;
  }
}
